import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Alert } from 'antd';
import queryString from 'query-string';
import { ApplicationState } from '../../reducers';
import { getSelectedBrandCode } from '../../selectors/brand/brandSelector';
import { intercomEvent } from '../../utils/IntercomUtils';
import { hasPermission } from '../../utils/Permissions';
import CustomAppsEmbedded from '../../components/body/settings/customApps/CustomAppsEmbedded';
import Page from '../../components/global/page/Page';
import { BRAND_AREA } from '../../constants/InAppAreaConst';

const ReplitContainer: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const { user, brandCode, inAppArea } = useSelector((state: ApplicationState) => ({
    user: state.user.user,
    brandCode: getSelectedBrandCode(state),
    inAppArea: state.app.global.inAppArea,
  }));

  const brandView = inAppArea === BRAND_AREA && location.pathname === '/brand/replit';
  const brandId = React.useMemo(() => {
    const values = queryString.parse(location.search);
    return values.brandId ? Number(values.brandId) : undefined;
  }, [location.search]);

  const canAccessReplit = useMemo(() => hasPermission(user, 'can_access_replit'), [user]);

  React.useEffect(() => {
    intercomEvent('viewed-custom-apps');
  }, []);

  if (!canAccessReplit) {
    return (
      <div className="p-5">
        <Alert
          showIcon
          type="info"
          message={t('common:noAccess')}
          description={t('replit:noPermission')}
        />
      </div>
    );
  }

  return (
    <Page>
      <CustomAppsEmbedded
        brandId={brandView ? brandId : undefined}
        brandCode={brandView ? brandCode : undefined}
      />
    </Page>
  );
};

export default ReplitContainer;
